<template>
  <div class="sched-app-print">
    <router-link to="/" class="no-print">go back</router-link>

  <h3>{{channelName}} Schedule</h3>
    <table>
      <tr>
        <td><b>Time</b></td>
        <td><b>Program</b></td>
        <td><b>Code</b></td>
      </tr>
      <tr v-for="(e, i) in data" :key="i">
        <td class="sched-app-print-time">{{formatTime(e.date)}}</td>
        <td class="sched-app-print-title">{{e.series_title}}</td>
        <td class="sched-app-print-code">{{e.program_code}}</td>
      </tr>
    </table>
  <!-- <div v-for="(e, i) in data" :key="i">
    <span class="print-time">{{formatTime(e.date)}}</span>
    <span class="print-title">{{e.series_title}}</span>
    <span class="print-program-code">{{e.program_code}}</span>
    </div> -->

  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  computed: {
    data () {
      return this.$store.state.schedData
    },
    channelName () {
      return this.$store.state.channel.label
    }
  },

  methods: {
    formatTime (d) {
      return moment(d).format('hh:mm A')
    }
  }
}
</script>

<style scoped>
@media print
{
    .no-print, .no-print *
    {
        display: none !important;
    }
}
.sched-app-print {
  padding-left: 20px;
}

.sched-app-print td {
  padding-right: 30px;
}
</style>
